import { styled } from '@mui/material';
import { SectionTitle } from '../../../styles/shared';
import Select from '../../../components/select/Select';

export const StyledContentWrapper = styled('div')(({ theme }) => ({
  color: theme.colors.secondaryText,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacings.unit(8),
  '@media print': {
    pageBreakInside: 'avoid',
    breakInside: 'avoid',
  },
}));

export const InfoWrapper = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacings.unit(8),
  [theme.breakpointsMediaQuery.up('lg')]: {
    flex: 0.7,
  },
}));

export const TechnicalAssets = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacings.unit(8),
  [theme.breakpointsMediaQuery.up('lg')]: {
    flex: 1.3,
  },
}));

export const TechnicalImages = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexWrap: 'wrap',
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const TechnicalImage = styled('span')(({ theme }) => ({
  position: 'relative',
  height: theme.spacings.unit(50),
  display: 'block',
  width: '50%',
  '& img': {
    // Keep it
    objectPosition: 'left',
  },
}));

export const TechnicalDataList = styled('table')(({ theme }) => ({
  '& > tr': {
    '& td:first-of-type': {
      color: theme.colors.primaryText,
      fontSize: theme.fonts.utility.size(7),
      fontWeight: 600,
      lineHeight: '150%',
      letterSpacing: theme.spacings.unit(0.06),
    },
    '& td:nth-of-type(2)': {
      color: theme.colors.tertiaryText,
      fontSize: theme.fonts.utility.size(7),
      fontWeight: 500,
      lineHeight: '150%',
    },
  },
}));

export const Key = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
}));

export const ButtonWrapper = styled('div')(({ theme }) => ({
  textAlign: 'center',
  '@media print': {
    visibility: 'hidden',
  },
}));

export const StyledButton = styled('button')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  padding: `${theme.spacings.unit(3.75)} ${theme.spacings.unit(6)}`,
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacings.unit(2),
  alignSelf: 'stretch',
  background: theme.colors.white,
  borderRadius: theme.spacings.unit(0.75),
  border: `${theme.spacings.unit(0.375)} solid ${theme.colors.primary}`,
  '& :hover': {
    cursor: 'pointer',
  },
}));

export const ButtonText = styled('span')(({ theme }) => ({
  color: theme.colors.mainTitleText,
  textAlign: 'center',
  fontSize: theme.fonts.utility.size(7),
  fontWeight: 800,
  lineHeight: '125%',
  letterSpacing: theme.spacings.unit(0.48),
  textTransform: 'uppercase',
  flex: '1 0 0',
}));

export const TitleWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacings.unit(6),
}));

export const StyledSectionTitle = styled(SectionTitle)(({ theme }) => ({
  marginBottom: 0,
  marginTop: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingRight: theme.spacings.unit(2),
  color: theme.colors.secondaryText,
  fontSize: theme.fonts.utility.size(10),
  fontWeight: 700,
  lineHeight: '140%',
  letterSpacing: theme.spacings.unit(-0.025),
}));

export const SelectStyled = styled((props: any) => <Select {...props} />)(
  ({ theme }) => ({
    color: theme.colors.primary,
    fontSize: theme.fonts.utility.size(8),
    fontWeight: 600,
    lineHeight: '145%',
    display: 'flex',
    padding: `${theme.spacings.unit(2.75)} ${theme.spacings.unit(4)}`,
    alignItems: 'center',
    gap: theme.spacings.unit(2),
    borderRadius: theme.spacings.unit(2),
    border: `${theme.spacings.unit('.25')} solid ${
      theme.colors.borderSecondary
    }`,
    background: theme.colors.white,
    boxShadow: `${theme.spacings.unit(0)} ${theme.spacings.unit(
      0.25
    )} ${theme.spacings.unit(0.5)} ${theme.spacings.unit(
      0
    )} rgba(0, 0, 0, 0.10)`,
    alignSelf: 'stretch',
    '& > svg': {
      top: 'auto',
      left: 'auto',
      right: theme.spacings.unit(4),
      transform: 'scale(1.2)',
      '& > path': {
        fill: theme.colors.drawerCaretDown,
      },
    },
    '@media print': {
      display: 'none',
    },
  })
);
